/**
 * Token meta verisi (çalışma zamanı değerleri src/styles/tokens.css'tedir). Bu modül yalnız bileşenlerin ve kataloğun
 * ihtiyaç duyduğu sabitleri taşır; renk değeri TEKRARLANMAZ.
 */
export const DENSITIES = ['compact', 'standard', 'comfortable'];
/**
 * Satır yükseklikleri (px) — tokens.css `[data-density]` ile aynı; test iki kaynağı karşılaştırır. Tema uyarlaması (20 Ekim
 * 2026, docs/tasarim/tema-uyarlama.md): standart 48, yoğun 40, rahat 56.
 */
export const ROW_HEIGHT = { compact: 40, standard: 48, comfortable: 56 };
/** Denetim (düğme, giriş) yükseklikleri (px) — tokens.css `[data-density]` ile aynı; standart 40 (dokunmatikte 44). */
export const CONTROL_HEIGHT = {
    compact: 36,
    standard: 40,
    comfortable: 44,
};
/** Üst bar yüksekliği (px) — `--cf-header-h`; ray markası ve panel başlığı aynı çizgide biter. */
export const HEADER_HEIGHT = 64;
/** Yarıçaplar (px) — `--cf-radius-*`: kart 8, denetim 6; hap (rozet, arama) tam yuvarlak. */
export const RADIUS = { card: 8, control: 6 };
/** Dokunmatik işaretçide en küçük etkileşim hedefi (px) */
export const MIN_TOUCH_TARGET = 44;
/** Kırılım noktaları (px): < md mobil (drawer), md–xl daraltılmış rail, ≥ xl tam sidebar */
export const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };
export const MEDIA = {
    mobile: `(max-width: ${BREAKPOINTS.md - 0.02}px)`,
    desktop: `(min-width: ${BREAKPOINTS.md}px)`,
    wide: `(min-width: ${BREAKPOINTS.xl}px)`,
    lgUp: `(min-width: ${BREAKPOINTS.lg}px)`,
};
/** Semantik renk token'ları (CSS değişken adı `--cf-<ad>`); katalog ve belge bu listeyi gösterir. */
export const COLOR_TOKENS = [
    { name: 'canvas', role: 'Uygulama zemini' },
    { name: 'surface', role: 'Çalışma yüzeyi (tablo, panel, form)' },
    { name: 'surface-subtle', role: 'Tablo başlığı, üzerine gelme, ikincil bölüm' },
    { name: 'surface-raised', role: 'Katman yüzeyi (menü, dialog); gölgeyle birlikte' },
    { name: 'border', role: 'Ayırıcı çizgiler (dekoratif)' },
    { name: 'border-strong', role: 'Form denetimi kenarı (≥ 3:1)' },
    { name: 'text', role: 'Birincil metin' },
    { name: 'text-muted', role: 'İkincil metin, tablo başlığı' },
    { name: 'text-subtle', role: 'Yardımcı metin, meta bilgi' },
    { name: 'primary', role: 'Ana eylem, etkin durum, bağlantı' },
    { name: 'primary-hover', role: 'Ana eylem üzerine gelme' },
    { name: 'primary-foreground', role: 'Ana eylem üzerindeki metin' },
    { name: 'primary-subtle', role: 'Etkin menü öğesi zemini' },
    { name: 'focus', role: 'Odak halkası (≥ 3:1)' },
    { name: 'selected', role: 'Seçili satır/öğe zemini' },
    { name: 'selected-border', role: 'Seçili öğe kenarı/işareti' },
    { name: 'success', role: 'Başarı metni/ikonu' },
    { name: 'success-subtle', role: 'Başarı zemini' },
    { name: 'warning', role: 'Uyarı metni/ikonu' },
    { name: 'warning-subtle', role: 'Uyarı zemini' },
    { name: 'danger', role: 'Hata ve geri alınamaz eylem' },
    { name: 'danger-hover', role: 'Geri alınamaz eylem üzerine gelme' },
    { name: 'danger-subtle', role: 'Hata zemini' },
    { name: 'info', role: 'Bilgi metni/ikonu' },
    { name: 'info-subtle', role: 'Bilgi zemini' },
    { name: 'disabled', role: 'Etkisiz denetim zemini' },
    { name: 'disabled-foreground', role: 'Etkisiz denetim metni' },
    { name: 'sidebar', role: 'Ana menü (sidebar) zemini — koyu teal' },
    { name: 'sidebar-hover', role: 'Menü öğesi üzerine gelme zemini' },
    { name: 'sidebar-active', role: 'Etkin menü öğesi zemini' },
    { name: 'sidebar-border', role: 'Sidebar içi ayırıcı' },
    { name: 'sidebar-fg', role: 'Sidebar birincil metni' },
    { name: 'sidebar-fg-muted', role: 'Sidebar ikincil metni (menü öğesi)' },
    { name: 'sidebar-heading', role: 'Sidebar grup başlığı' },
    { name: 'sidebar-accent', role: 'Etkin öğe işareti ve sidebar odak halkası' },
    { name: 'note', role: 'İç not zemini (müşteriye gitmez)' },
    { name: 'note-border', role: 'İç not kenarı' },
];
//# sourceMappingURL=tokens.js.map